module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point2_1-db61e37497ccedba4504775f5326d628.jpg";